import type { InventoryListsListFilters } from '@openx/types/inventoryList';
import { type AllTableCriteria, SortDirection } from '@openx/types/tableCriteria';

type AdjustedCriteria = {
  name?: string;
  account_uid?: string[];
  limit?: number;
  offset?: number;
  sort?: string;
};

export const adjustCriteriaFilters = (criteria: AllTableCriteria<InventoryListsListFilters>): AdjustedCriteria => {
  const criteriaObj: AdjustedCriteria = {};

  if (criteria.filters?.phrase) {
    criteriaObj.name = criteria.filters.phrase;
  }

  if (criteria.filters?.account_uid?.length) {
    criteriaObj.account_uid = criteria.filters.account_uid;
  }

  if (criteria.pagination) {
    criteriaObj.limit = criteria.pagination.pageSize;
    criteriaObj.offset = (criteria.pagination.pageNumber - 1) * criteria.pagination.pageSize;
  }

  if (criteria.sort?.column) {
    const direction = criteria.sort.direction === SortDirection.ASC ? '' : '-';

    criteriaObj.sort = direction + criteria.sort.column;
  }

  return criteriaObj;
};
